
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/joy-ui/react-menu",
      function () {
        return require("private-next-pages/joy-ui/react-menu.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/joy-ui/react-menu"])
      });
    }
  